<div class="worker flex-column p-relative" [ngClass]="{'collapsed': !isVisible}" [ngStyle]="{'height': !isVisible ? '40px' : '130px'}">
    <div class="worker-info flex-column h-100 justify-between" [ngClass]="{'inactive': !isActive}">
        <div>
            <div class="worker-name flex">
                <span>{{worker.data.id}}</span>
                <h5>{{worker.data.firstName}} {{worker.data.lastName}}</h5>
                @if (!isVisible) {
                    <span>Задач: {{workerTasks.length}}</span>
                }
            </div>
            @if (isVisible) {
                @if (worker.getStartWorkTime(getDate()) && worker.getEndWorkTime(getDate())) {
                    <div class="work-time">
                        <span>Рабочее время {{ worker.getStartWorkTime(getDate()) }} - {{worker.getEndWorkTime(getDate()) }}</span>
                    </div>
                } @else {
                    <div class="work-time">
                        <span>Выходной день</span>
                    </div>
                }

                <div>
                    <span>{{workTime.hours}} ч.</span>
                    <span>{{workTime.minutes}} мин.</span>
                </div>
            }
        </div>

        @if (isVisible) {
            <div class="flex justify-between">
                <app-tasks-count [workerTasks]="workerTasks"/>
            </div>
        }

    </div>
    <div class="visibility flex-column p-absolute" [ngStyle]="{'justify-content': isVisible ? 'space-around' : '', 'height': isVisible ? '' : '40px'}">
        @if(isVisible) {
            <mat-icon id="show" (click)="showHide()" matTooltip="Показать работника">visibility</mat-icon>
            <div>
                <mat-icon matTooltip="Обмен заявок с другим сотрудником"
                          (click)="replaceTAsks()"
                >
                    compare_arrows
                </mat-icon>
            </div>

            <div>
                <mat-slide-toggle
                    [checked]="isActive"
                    (change)="changeStatus($event)"
                    matTooltip="Изменить статус работника"
                    data-testid="status-worker-toggle"
                >
                </mat-slide-toggle>
            </div>
        } @else {
            <mat-icon id="hide" (click)="showHide()" matTooltip="Скрыть работника">visibility_off</mat-icon>
        }


    </div>
</div>
